import Text from 'components/Text/Text';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import React, { useContext } from 'react';
import style from './DropdownMenu.module.scss';

const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IScheduleViewContext>(ScheduleViewContext);

	return (
		<div className={style.container}>
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="form" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text translationNameSpace="form" translationKey="sortByTypeLabel" theme="neutralLight" size="s" />
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByTypeA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('PushesA-Z')}
						checked={sortBy === 'PushesA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByTypeZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('PushesZ-A')}
						checked={sortBy === 'PushesZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByDateTimeLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByDateTime1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Date/Time1-10')}
						checked={sortBy === 'Date/Time1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByDateTime10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Date/Time10-1')}
						checked={sortBy === 'Date/Time10-1'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default DropdownMenu;
